import React from 'react'
import ReactDOM from 'react-dom/client'
import { registerSW } from 'virtual:pwa-register'
import App from './App.tsx'
import './index.css';
import './colors.css';
import './rtl.css'; // RTL CSS support
import GlobalFont from './GlobalFont';
import './i18n'; 
import { performCountryRedirectIfNeeded } from './hooks/useCountryRedirect';
import { initPwaInstallListener, updatePwaManifestForRoute } from './utils/pwaInstall';

updatePwaManifestForRoute(window.location.pathname);
initPwaInstallListener();

registerSW({ immediate: true });

const root = ReactDOM.createRoot(document.getElementById('root')!);

root.render(
  <React.StrictMode>
    <GlobalFont />
    <App />
  </React.StrictMode>,
);

// Run in background so IP lookup does not delay first paint.
void performCountryRedirectIfNeeded();
